import styled from 'styled-components';

import colors from '../../../../../styles/colors';
import { HeaderRow } from '../../../../../components/v2/Header';

const CommentsNotificationContainer = styled.div`
  background-color: ${colors.base.gamma};
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 60%;
  overflow-y: scroll;
  padding: 10px;
`;

const EmptyContainer = styled.div`
  display: flex;
  padding: 20px;
`;

const StyledHeaderRow = styled(HeaderRow)`
  width: 58%;
`;

export {
  CommentsNotificationContainer,
  EmptyContainer,
  StyledHeaderRow,
};
